import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
import { getPaymentSessionTemplatesKey, getPaymentEligibilityKey
// @ts-expect-error untyped dependency
} from 'FormsUI/earlyRequest/earlyRequestsShared';
const SALES_CHECKOUT_BASE_URL = '/sales-checkout/v2';
const PAYMENT_ELIGIBILITY_BASE_URL = '/payments/v1';
const _fetchPaymentSessionTemplates = () => http.get(`${SALES_CHECKOUT_BASE_URL}/session-templates/active`);
export const getPaymentSessionTemplates = () => getFromEarlyRequest(getPaymentSessionTemplatesKey(), () => _fetchPaymentSessionTemplates());
const _fetchPaymentEligibility = () => http.get(`${PAYMENT_ELIGIBILITY_BASE_URL}/payment-accounts/eligibility`);
export const getPaymentEligibility = () => getFromEarlyRequest(getPaymentEligibilityKey(), () => _fetchPaymentEligibility());
export const getCheckoutSessionPreview = paymentSessionTemplateId => http.get(`payments-checkout/v1/checkout-session-previews/${paymentSessionTemplateId}`);